const state = {
  // 定位数据
  localPosition: null,
  // 用户信息
  userinfo: null,
  // 微信绑定用户的unionid
  unionid: null,
  // 搜索历史
  searchCondition: null,
  // 当前定位城市
  city: null,
  // 医院列表页切换城市
  switchCity: null,
  // 首页切换搜索条件
  searchModule: null,
  // 套餐详情
  mealDetail: null,
  // 下单体检人信息
  orderUserInfo: null,
  // 日期选择
  dateChosen: null,
  // 代金券
  voucher: null,
  // 体检人信息
  mealPersonInfo: null,
  // 图表数据
  echartsData: null,
  // 评估结果
  assessmentData: null,
  //套餐详情下一步按钮有加项情况下弹窗是否第一次出现
  isFirst:true,
  // 加项id列表
  selectItemList: [],
  // 加项项目详情列表
  selectItemContentList: [],
  // 加项包id列表
  selectItemPackageList: [],
  // 加项包项目详情列表
  selectItemPackageContentList: [],
  // 加项总价格
  addItemPrice: '0.00',
  recommendResult: [],
  //中医链接的渠道id
  medicineChineseConfig: null,
  // 设备相关
  deviceOpenId: null,
  // 设备用户详情
  deviceUserDetails: null,
  //中医体质辨识流程类型
  medicineChineseIdentifyType:0,
  // 当天是否存在未完成问卷
  isEvaluationUnFinish: false,
  // 订单详情
  orderDetail: null,
  // 发票详情
  invoiceDetail: null,
  // 发票更多信息
  invoiceMoreInfo: null,
  // 快速提问信息
  quickQuestionInfo: null,
  // 选中的体检报告，用于会话聊天发送体检报告信息
  selectReportInfo: null,
  //当前智能机器人获取问卷信息
  questionRobotInfo:null
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js